import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-locate-microchip-step',
  templateUrl: './locate-microchip-step.component.html',
  styleUrls: ['./locate-microchip-step.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LocateMicrochipStepComponent implements OnInit {
  @Input() positioning: string = '';
  @Input() title: string;
  @Input() text: string;
  @Input() dataBeforeContent: string;
  @Input() listHeader?: string;
  @Input() listDots?: Array<string>;

  constructor() {}

  ngOnInit(): void {}
}
